import React, { PropsWithChildren, useEffect, useState } from "react";
import { GamesSearchInputWebView } from "@/components/webview/games/shared/GamesSearchInputWebView";
import { cn } from "@/libs/utils";
import { Heading1 } from "@/components/webview/games/typograpy/typograpy-webview";
import { useTrans } from "@/utils/useTrans";

export const GameTemplateWebView = ({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) => {
  const { t } = useTrans(["games"]);
  const [isIOSWebView, setIsIOSWebView] = useState(false);

  // ios 일떈 title 노출
  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes("ios-webview")) {
      setIsIOSWebView(true);
    }
  }, []);

  if (isIOSWebView) {
    return (
      <div className={cn("flex flex-col bg-black")}>
        <div className="sticky top-0 z-[99999] bg-black pb-2">
          <GameTemplateTitleWebview title={t("Game")} />
          <GamesSearchInputWebView />
        </div>
        {children}
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col bg-black pt-[56px]")}>
      <div className="sticky top-[56px] z-[99999] bg-black pb-2">
        <GamesSearchInputWebView />
      </div>
      {children}
    </div>
  );
};

const GameTemplateTitleWebview = ({ title }: { title: string }) => (
  <Heading1 className="px-4 font-500 text-white">{title}</Heading1>
);
